(function () {
    'use strict';

    a3_cabin_reports.factory('WifiAvailabilityFactory', WifiAvailabilityFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name WifiAvailabilityFactory
    * @description 
    *   Storage of aircraft registrations with Wi-Fi connectivity.
    * @ngInject
    */
    function WifiAvailabilityFactory(GenericService) {

        var objType = 'WifiAvailability';
        var objCallback = WifiAvailability;


        /**
         * Initialize the WifiAvailability
         * @memberof WifiAvailabilityFactory
         */
        function WifiAvailability() {
            this.Registrations = [];
        }

        var service = {
            setRegistrationsToStorage: setRegistrationsToStorage,
            getRegistrationsFromStorage: getRegistrationsFromStorage,
        };

        /**
         * Save registrations with Wi-Fi connectivity to storage
         * @param {array} objList A list of aircraft registrations
         */
        function setRegistrationsToStorage(objList) {
            if (objList != null) {
                var registrations = { registrations: objList};
                GenericService.saveOne(registrations, objType, objCallback);
            }
        }

        /**
         * Get registrations from storage
         */
        function getRegistrationsFromStorage() {
            return GenericService.getOne(objType, objCallback);
        }

        return service;
    }
})();